// extracted by mini-css-extract-plugin
export default {"formItem":"Button_formItem__wzq4V","primary":"Button_primary__TbjX9","secondary":"Button_secondary__adaSq","danger":"Button_danger__+i9-G"};